<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="room">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            房间列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <div style="float:right">
                        <el-select v-model="buildingCode" placeholder="请选择楼宇" clearable style="margin:0 10px;float:left">
                            <el-option
                                    v-for="item in buildingCodeValue"
                                    :key="item.buildingCode"
                                    :label="item.name"
                                    :value="item.buildingCode">
                            </el-option>
                        </el-select>
                        <el-input  placeholder="请输入房间号" v-model.number="number" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="roomTypeCode" placeholder="选择房间类型" style="margin:0 10px;" clearable>
                            <el-option
                                    v-for="item in roomTypeList"
                                    :key="item.roomTypeCode"
                                    :label="item.name"
                                    :value="item.roomTypeCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="status" placeholder="选择房间状态" style="margin:0 10px;" >
                            <el-option
                                    v-for="item in statusValue"
                                    :key="item.val"
                                    :label="item.name"
                                    :value="item.val">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="buildingName" label="楼宇名称"></el-table-column>

                        <el-table-column prop="floor" label="第几层"></el-table-column>

                        <el-table-column prop="number" label="房间号"></el-table-column>

                        <el-table-column
                                prop="roomTypeDTO.name"
                                label="房间类型">
                        </el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd"  v-bind:roomTypeList="roomTypeList" v-bind:buildingCodeValue="buildingCodeValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:roomTypeList="roomTypeList"  v-bind:buildingCodeValue="buildingCodeValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                showModalAdd:false,
                showModalEdit:false,
                disabledAdd:true,
                disabledEdit:true,
                menuButtonList:null,
                tableData:null,
                status:-1,
                roomTypeCode:'',
                buildingCode:'',
                number:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                selectInfo:'',
                buildingCodeValue:[],
                roomTypeList:[],
                statusValue:[{
                    val:-1,
                    name:'全部'
                },{
                    val:0,
                    name:'正常'
                },{
                    val:1,
                    name:'禁用'
                }],
                 roomTypeValue: [{
                    value: 0,
                    label: '单人间'
                },{
                    value: 1,
                    label: '单人间'
                }, {
                    value: 2,
                    label: '双人间'
                }],
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.init();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                console.log(menu);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
             init:function(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Building/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.buildingCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoomType/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.roomTypeList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            handleChange(value) {
                this.roomCode=value[1];
                console.log(this.roomCode);
            },
            handleEdit() {
                this.$refs.myEdit.init(this.selectInfo);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                var buildingCode=this.buildingCode
                var roomTypeCode=this.roomTypeCode
                var number=-1
                if(!buildingCode){buildingCode='00000000-0000-0000-0000-000000000000'}
                if(!roomTypeCode){roomTypeCode='00000000-0000-0000-0000-000000000000'}
                if(this.number){
                    number=this.number
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Room/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        buildingCode:buildingCode,
                        roomTypeCode:roomTypeCode,
                        number:number,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                const statusValue=this.statusValue
                for(var i in statusValue){
                    if(statusValue[i].val==row.status){
                        return statusValue[i].name
                    }
                }   
            },
             roomTypeTitle(row){
                return row.roomType+' 人间'
            },
             rowClick(row){
                this.selectInfo=row
                console.log(this.menuButtonList.indexOf("编辑"))
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
            }


        }
    }
</script>

<style lang='scss' scoped>
    .room /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
